import React, { useState, useEffect, useContext } from 'react';

import DetailsSection, { initializeTrumbowyg } from './detailsSection';
import CustomFieldsSection from './custom_fields/customFieldsSection';
import AdvancedSection from './advanced/AdvancedSection';
import TemplatingSection from './templating/TemplatingSection';
import SectionBar, { SectionDetails } from './sectionBar';
import { AssetDetailsDispatch, FlattenedAttachment } from '../EditTabTypes';
import assetModalContext from '../asset_modal_context';

import './styles/_main.scss';

interface GenericFileEditFormScopedContext {
  state: {
    initialData: {
      assetKey: string;
    };
    editState: {
      assetDescription: string;
      attachments: FlattenedAttachment[];
    };
  };
  dispatch: AssetDetailsDispatch;
}

const GenericFileEditForm = ({ includeAdvancedOptions }: { includeAdvancedOptions?: boolean }): JSX.Element => {
  const { state, dispatch }: GenericFileEditFormScopedContext = useContext(assetModalContext);
  const { assetDescription, attachments } = state.editState;

  const [textareaVisible, setTextareaVisible] = useState(true);
  const hasTemplateAttachmentKey = (): string => (
    attachments?.find((attachment: FlattenedAttachment) => attachment.mimetype === "brandfolder/template")?.key || ''
  );

  const sections: SectionDetails[] = [{
    displayName: t('Details'),
    content: (
      <DetailsSection />
    ),
    onActiveSection: (): void => setTextareaVisible(true)
  }];
  if (BFG.hasFeature('custom_fields')) {
    sections.push({
      tabClassName: 'custom-fields',
      displayName: t('Custom Fields'),
      content: <CustomFieldsSection />,
      onActiveSection: (): void => setTextareaVisible(false)
    });
  }

  sections.push({
    displayName: t('Advanced'),
    content: <AdvancedSection includeAdvancedOptions={includeAdvancedOptions} />,
    onActiveSection: (): void => setTextareaVisible(false)
  });

  const templateAttachmentKey = hasTemplateAttachmentKey();
  if (templateAttachmentKey) {
    sections.push({
      displayName: t('Templating'),
      content: <TemplatingSection attachmentKey={templateAttachmentKey} />,
      onActiveSection: (): void => setTextareaVisible(false),
      tabClassName: 'templating',
    });
  }

  useEffect(() => {
    if (textareaVisible) {
      initializeTrumbowyg(assetDescription, dispatch);
    } else {
      // if not on details tab, kill trumbowyg
      ($('#asset-description-textarea') as TrumbowygJquery).trumbowyg('destroy');
    }
  }, [textareaVisible]);

  return (
    <div className="edit-tab-main-pane two-thirds bf-scroll-element">
      <SectionBar sections={sections} />
    </div>
  );
};

export default GenericFileEditForm;
